import React from "react";

export function LinkedinIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="linkedin"
      {...props}
    >
      <path
        d="M3.63275 15H0.203954V4.87917H3.63275V15ZM1.9185 3.49775H1.89596C0.745617 3.49775 0 2.72032 0 1.74845C0 0.776585 0.767284 0 1.94074 0C3.1142 0 3.83584 0.755328 3.85837 1.74845C3.85837 2.72032 3.11449 3.49775 1.9185 3.49775ZM16 15H12.5703V9.58516C12.5703 8.22529 12.0749 7.29678 10.8335 7.29678C9.88542 7.29678 9.32209 7.92174 9.07394 8.52742C8.9838 8.74367 8.96012 9.04438 8.96012 9.34765V15H5.52958C5.52958 15 5.57552 5.82864 5.52958 4.87917H8.96012V6.3133C9.41598 5.62514 10.2292 4.64166 12.0512 4.64166C14.3083 4.64166 16 6.08769 16 9.1963V15Z"
        fill={props.fill}
      />
    </svg>
  );
}
